import Loading from "vue-loading-overlay";
import Sidebar from "../../layout/Sidebar.vue";
import {authHeader} from "../../../auth";

    export default {
        name: "OrderDetail",
        components: {
            Sidebar,
            Loading
        },
        data() {
            return {
                isLoading: false,
                fullPage: true,
                loader: "bars",
                getOrderURL: "api/purchase/get-detail-order",
                orderDetailData: [],
                message: "",
                statusMessage: "No Record Found"
            }
        },
        created() {
            document.title = 'Geek Buy Back - Order Details';
            //this.getDataList({'url': 'site/info'}); 
            this.getOrderDetails();
        },
        methods:{
            getOrderDetails: function() {
                this.isLoading = true;
                var config = {
                    method: "GET",
                    url: this.$api + this.getOrderURL + '/' + this.$route.params.invoiceID,
                    headers: authHeader()
                };
                
                this.$axios(config).then(response => {
                    console.log(response.data);
                    this.orderDetailData = response.data;
                    if(this.orderDetailData.length == 0)
                    {
                        this.message = this.statusMessage;
                    }
                    this.isLoading = false;
                }).catch(e => {
                    console.log(e);
                    this.isLoading = false;
                });
            },
        }
    }